import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import type React from 'react';

interface CarouselLoopProps {
  children: React.ReactNode[];
  itemWidth: number;
  itemMargin?: number;
  speedMultiplier?: number;
  stoppage?: boolean;
}

const CarouselLoop: React.FC<CarouselLoopProps> = ({
  children,
  itemWidth,
  itemMargin = 16,
  speedMultiplier = 3,
  stoppage = false,
}) => {
  const totalItemWidth = itemWidth + itemMargin;
  const totalWidth = children.length * totalItemWidth;

  return (
    <Box sx={{ backgroundColor: 'backgroundGrey.main', overflow: 'hidden', py: 0 }}>
      <Container maxWidth="xl" disableGutters>
        <Box
          sx={{
            display: 'flex',
            whiteSpace: 'nowrap',
            animation: `scroll ${children.length * speedMultiplier}s linear infinite`,
            ...(stoppage && {
              '&:hover': {
                animationPlayState: 'paused',
              },
            }),
            '@keyframes scroll': {
              '0%': { transform: 'translateX(0)' },
              '100%': { transform: `translateX(-${totalWidth}px)` },
            },
          }}
        >
          {[...children, ...children].map((child, idx) => (
            <Box
              key={`carousel-item-${idx}`}
              sx={{
                width: itemWidth,
                mx: itemMargin / 2,
                flexShrink: 0,
              }}
            >
              {child}
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default CarouselLoop;
